<template>
    <div class="ion-page">
        <ion-header>
        <ion-toolbar>
            <ion-buttons slot="start">
            <ion-menu-button></ion-menu-button>
            </ion-buttons>

            <ion-title>Corporates List</ion-title>

            <ion-buttons slot="end">
            <ion-button @click="addCorporateDetails" v-if="rightToAdd">
                <ion-icon slot="start" name="add"></ion-icon>Add New Corporate Details
                <!-- <ion-icon slot="icon-only" name="add"></ion-icon>  class="btn-add" -->
            </ion-button>
            </ion-buttons>
        </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
        <Corporates />
        </ion-content>
    </div>
</template>

<script>
import { defineComponent } from "vue";
// @ is an alias to /src
import ChargingStations from "@/components/admin/ChargingStations.vue";
import Corporates from "@/components/corporate/corporates.vue";

import { AppUtils } from "@/util/app-utils"
import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonMenuButton, IonTitle, IonToolbar } from "@ionic/vue";

export default defineComponent ({
    name: 'corporates',
    components: {
        Corporates, IonHeader, IonToolbar, IonButtons, IonMenuButton, IonTitle, IonIcon, IonButton, IonContent
    },
    data() {
        return {
            rightToAdd: false
        }
    },
    mounted() {
        this.rightToAdd = new AppUtils().getUserAccess("100|L");
    },
    methods: {
        addCorporateDetails() {
        this.$router.push("/corporate/corporateDetails");
        }
    }
})
</script>